/* FILOSOGNO v4 — product page + cards interactions */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Gallery: swipe progress (mobile) + inspect zoom (desktop) ---------- */
  $$('[data-p4-gal]').forEach(g => {
    const track = $('[data-track]', g), slides = $$('[data-slide]', g), bars = $$('[data-bar]', g), thumbs = $$('[data-thumb]', g);
    const setActive = i => {
      bars.forEach((b, j) => b.classList.toggle('on', j <= i));
      thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
    };
    if (bars.length) {
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting && e.intersectionRatio > .6) setActive(slides.indexOf(e.target));
      }), { root: track, threshold: [.6] });
      slides.forEach(s => io.observe(s));
      setActive(0);
    }
    if (fine) slides.forEach(s => {
      s.addEventListener('pointermove', e => {
        const r = s.getBoundingClientRect();
        s.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        s.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
      s.addEventListener('click', () => s.classList.toggle('is-zoom'));
      s.addEventListener('pointerleave', () => s.classList.remove('is-zoom'));
    });
  });

  /* ---------- Magic ring: crochet chart drawn round by round on scroll ---------- */
  $$('[data-ring]').forEach(sec => {
    const svg = $('[data-ring-svg]', sec), countEl = $('[data-ring-count]', sec), rows = $$('[data-row]', sec);
    const NS = 'http://www.w3.org/2000/svg';
    // Each round: list of symbols ('x' = single crochet, 'v' = increase), radius, stitch total
    const rounds = [
      { r: 54, sym: Array(6).fill('x'), total: 6 },
      { r: 82, sym: Array(6).fill('v'), total: 12 },
      { r: 112, sym: Array.from({ length: 12 }, (_, i) => i % 2 ? 'v' : 'x'), total: 18 },
      { r: 142, sym: Array.from({ length: 18 }, (_, i) => i % 3 === 2 ? 'v' : 'x'), total: 24 }
    ];
    const marks = [];
    rounds.forEach((rd, ri) => {
      const c = document.createElementNS(NS, 'circle');
      c.setAttribute('r', rd.r); c.setAttribute('class', 'rnd'); svg.appendChild(c);
      rd.sym.forEach((s, i) => {
        const a = (i / rd.sym.length) * Math.PI * 2 - Math.PI / 2 + ri * 0.18;
        const x = Math.cos(a) * rd.r, y = Math.sin(a) * rd.r;
        const deg = a * 180 / Math.PI + 90;
        const p = document.createElementNS(NS, 'path');
        p.setAttribute('d', s === 'x' ? 'M-5,-5 L5,5 M5,-5 L-5,5' : 'M0,7 L-6,-7 M0,7 L6,-7');
        p.setAttribute('transform', `translate(${x.toFixed(2)} ${y.toFixed(2)}) rotate(${deg.toFixed(1)})`);
        p.setAttribute('class', 'st' + (s === 'v' ? ' inc' : ''));
        svg.appendChild(p);
        marks.push({ el: p, round: ri });
      });
    });
    const N = marks.length;
    let shown = -1;
    const paint = n => {
      if (n === shown) return; shown = n;
      marks.forEach((m, i) => m.el.classList.toggle('on', i < n));
      const last = n > 0 ? marks[Math.min(n, N) - 1].round : -1;
      rows.forEach((r, i) => r.classList.toggle('on', i <= last && n > 0));
      countEl.textContent = last >= 0 ? rounds[last].total : 0;
    };
    if (reduce) { paint(N); return; }
    let ticking = false;
    const update = () => {
      ticking = false;
      const r = sec.getBoundingClientRect(), vh = innerHeight;
      const p = Math.min(1, Math.max(0, (vh * 0.8 - r.top) / (r.height * 0.75)));
      paint(Math.round(p * N));
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    addEventListener('resize', update);
    update();
  });

  /* ---------- Inside the tutorial: pages fan out, follow the pointer ---------- */
  $$('[data-pages]').forEach(box => {
    if (reduce) { box.classList.add('is-open'); return; }
    new IntersectionObserver(([e], o) => { if (e.isIntersecting) { box.classList.add('is-open'); o.disconnect(); } }, { threshold: .35 }).observe(box);
    if (fine) {
      box.addEventListener('pointermove', e => {
        const r = box.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        box.style.transform = `rotateY(${(x * 7).toFixed(2)}deg) rotateX(${(-y * 5).toFixed(2)}deg)`;
      });
      box.addEventListener('pointerleave', () => { box.style.transform = ''; });
      box.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
      box.style.transformStyle = 'preserve-3d';
    }
  });

  /* ---------- Sticky buy bar ---------- */
  const buy = $('[data-p4-buy]'), bar = $('[data-bar4]');
  if (buy && bar) {
    const btn = $('button', bar);
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }).observe(buy);
  }

  /* ---------- Cards: load hover image before it is needed ---------- */
  if (fine) {
    const cio = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return;
      const alt = e.target.querySelector('.c4__alt'); if (alt) alt.loading = 'eager';
      cio.unobserve(e.target);
    }), { rootMargin: '300px 0px' });
    $$('.c4').forEach(c => cio.observe(c));
  }

  /* ---------- Collection cards: carousel dots (mobile) ---------- */
  $$('[data-col5]').forEach(sec => {
    const track = $('[data-col5-track]', sec), cards = $$('[data-col5-card]', sec), dots = $$('[data-col5-dot]', sec);
    if (!dots.length) return;
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting && e.intersectionRatio > .6) dots.forEach((d, i) => d.classList.toggle('on', i === cards.indexOf(e.target)));
    }), { root: track, threshold: [.6] });
    cards.forEach(c => io.observe(c)); dots[0].classList.add('on');
  });

  /* ---------- Atelier: steps swap the sticky image ---------- */
  $$('[data-steps]').forEach(sec => {
    const items = $$('[data-step]', sec), imgs = $$('[data-stage]', sec);
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return;
      const i = +e.target.dataset.step;
      items.forEach((x, j) => x.classList.toggle('on', j === i));
      imgs.forEach((x, j) => x.classList.toggle('on', j === i));
    }), { rootMargin: '-45% 0px -45% 0px' });
    items.forEach(x => io.observe(x));
  });

  /* ---------- Featured grid filter with FLIP ---------- */
  $$('[data-feat]').forEach(sec => {
    const tabs = $$('[data-filter]', sec), grid = $('[data-grid]', sec), cards = $$('.c4', grid);
    tabs.forEach(t => t.addEventListener('click', () => {
      const f = t.dataset.filter;
      tabs.forEach(x => x.setAttribute('aria-selected', x === t ? 'true' : 'false'));
      const before = new Map(cards.filter(c => !c.classList.contains('is-hidden')).map(c => [c, c.getBoundingClientRect()]));
      cards.forEach(c => c.classList.toggle('is-hidden', f !== '*' && c.dataset.col !== f));
      if (reduce) return;
      cards.filter(c => !c.classList.contains('is-hidden')).forEach((c, i) => {
        const a = c.getBoundingClientRect(), b = before.get(c);
        if (b) {
          const dx = b.left - a.left, dy = b.top - a.top;
          if (dx || dy) c.animate([{ transform: `translate(${dx}px,${dy}px)` }, { transform: 'none' }], { duration: 650, easing: 'cubic-bezier(.22,1,.36,1)' });
        } else {
          c.animate([{ opacity: 0, transform: 'translateY(18px) scale(.98)' }, { opacity: 1, transform: 'none' }], { duration: 600, delay: i * 45, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
        }
      });
    }));
  });
})();
